import type { ReactNode } from 'react';
import './PageHeader.css';

export interface PageHeaderProps {
  title: ReactNode;
  /** A short line under the title: the state and why, or a count. */
  subtitle?: ReactNode;
  /** A chip beside the title, usually the state badge. */
  badge?: ReactNode;
  /** Breadcrumb or back link rendered above the title. */
  eyebrow?: ReactNode;
  /** Primary and secondary actions, right-aligned. */
  actions?: ReactNode;
}

export function PageHeader({
  title,
  subtitle,
  badge,
  eyebrow,
  actions,
}: PageHeaderProps): ReactNode {
  return (
    <header className="pui-page-header">
      <div className="pui-page-header__main">
        {eyebrow ? <div className="pui-page-header__eyebrow">{eyebrow}</div> : null}
        <div className="pui-page-header__title-row">
          <h1 className="pui-page-header__title">{title}</h1>
          {badge}
        </div>
        {subtitle ? <p className="pui-page-header__subtitle">{subtitle}</p> : null}
      </div>
      {actions ? <div className="pui-page-header__actions">{actions}</div> : null}
    </header>
  );
}
